import { AnimatePresence } from "framer-motion";
import { useState } from "react";
import { CreditCard, Timer } from "lucide-react";

import DataFetcherTemplateHome2 from "../../hooks/DataFetcherTemplate2";
import BlockImageCabecera from "../../components/BlockImageCabecera";
import BlockLeftImage from "../../components/BlockLeftImage";
import BlockRightImage from "../../components/BlockRightImage";
import ImageGallery from "../../components/ImageGallery";
import Accordion from "../../components/Accordion";

const url =
  "https://portales.utpl.edu.ec/beportales/jsonapi/node/template_home/d5837888-c4df-4981-b441-e25b49be8e54" +
  "?include=field_imagen_portada.field_media_image,field_imagen13.field_media_image," +
  "field_gallery.field_media_image,field_gallery1.field_media_image," +
  "field_imagen5.field_media_image," +
  "field_imagen6.field_media_image," +
  "field_imagen14.field_media_image,field_imagen15.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4,field_bloque5,field_bloque6,field_bloque7,field_bloque8,field_bloque9,field_bloque10,field_bloque11,field_bloque12,field_bloque13,field_bloque14,field_bloque15," +
  "field_gallery,field_gallery1,field_bloque16,field_bloque17,field_bloque18,field_bloque19,field_bloque20,field_bloque21,field_bloque22,field_bloque23,field_bloque24,field_bloque25,field_bloque26,field_bloque27,field_bloque28,field_bloque29,field_bloque30," +
  "field_imagen5,field_imagen6,field_imagen13,field_imagen14,field_imagen15" +
  "&fields[media--image]=field_media_image";

export default function UTE() {
  const DataDisplay = ({ data }) => (
    <div>
      <BlockImageCabecera
        src={data.imagen_portada}
        title={
          <div
            dangerouslySetInnerHTML={{
              __html: data.texto_portada,
            }}
          />
        }
      />

      {data.bloque1 && (
        <section className="bluebg">
          <div className="max-w-6xl m-auto px-6 py-24">
            <div
              className="  button-a [&_a]:m-auto"
              dangerouslySetInnerHTML={{
                __html: data.bloque1,
              }}
            />
            <div
              dangerouslySetInnerHTML={{
                __html: data.bloque2,
              }}
            />
          </div>
        </section>
      )}

      <section className="py-24 bg-slate-50 ">
        <div
          className=" max-w-6xl m-auto px-6 link-with-arrow-1  "
          dangerouslySetInnerHTML={{
            __html: data.bloque3,
          }}
        />
      </section>

      <section className="py-24   ">
        <div
          className=" max-w-6xl m-auto px-6 link-with-arrow-1  "
          dangerouslySetInnerHTML={{
            __html: data.bloque4,
          }}
        />
      </section>

      <section className="py-24 bg-slate-50 ">
        <div
          className=" max-w-6xl m-auto px-6 link-with-arrow-1  "
          dangerouslySetInnerHTML={{
            __html: data.bloque5,
          }}
        />
      </section>

      <section className="py-24   ">
        <div className="max-w-6xl m-auto px-6 ">
          <div
            className=" link-with-arrow-1  "
            dangerouslySetInnerHTML={{
              __html: data.bloque6,
            }}
          />

          <div className="mt-10"> 
          <Accordion
            title="Proceso de matriculación"
            content={
              <>
                <div
                  className=" max-w-6xl m-auto px-6 link-with-arrow-1  "
                  dangerouslySetInnerHTML={{
                    __html: data.bloque7,
                  }}
                />
              </>
            }
          ></Accordion></div>
        </div>
      </section>
    </div>
  );

  return (
    <DataFetcherTemplateHome2 url={url}>
      {(data) => (
        <AnimatePresence mode="wait">
          <DataDisplay key="data-loaded" data={data} />
        </AnimatePresence>
      )}
    </DataFetcherTemplateHome2>
  );
}
